'use strict';

var React = require('react');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const htmlTagByVariant = {
    'heading-1': 'h1',
    'heading-2': 'h2',
    'heading-3': 'h3',
    'heading-4': 'h4',
    'heading-4-light': 'h4',
    'heading-5': 'h5',
    'heading-5-light': 'h5',
    subtitle: 'h6',
    'subtitle-light': 'h6',
};
const Heading = React.forwardRef(({ as, color, display = 'block', variant, ...props }, ref) => (React__default.default.createElement(styles.Styled.Div, { ...props, as: as ?? htmlTagByVariant[variant], color: color, display: display, ref: ref, variant: variant })));

exports.Heading = Heading;
exports.htmlTagByVariant = htmlTagByVariant;
//# sourceMappingURL=component.js.map
